// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--1-oneOf-2-2!../../../node_modules/postcss-loader/lib/index.js??postcss!./style.css");
if(typeof content === 'string') content = [[module.id, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":false}
options.transform = transform
// add the styles to the DOM
var update = require("!../../../node_modules/style-loader/lib/addStyles.js")(content, options);
if(content.locals) module.exports = content.locals;



//////////////////
// WEBPACK FOOTER
// ./src/Pages/PrivacyPolicy/style.css
// module id = 837
// module chunks = 14